const IN_PROGRESS_KEY = "inProgressDocumentIds";

export function getInProgressIds(): string[] {
  try {
    const raw = localStorage.getItem(IN_PROGRESS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((x: unknown) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function setInProgressIds(ids: string[]): void {
  try {
    localStorage.setItem(IN_PROGRESS_KEY, JSON.stringify(Array.from(new Set(ids))));
  } catch {}
}

export function trackInProgress(documentId: string): void {
  const ids = getInProgressIds();
  if (!ids.includes(documentId)) {
    ids.push(documentId);
    setInProgressIds(ids);
  }
}

export function untrackInProgress(documentId: string): void {
  const ids = getInProgressIds().filter((id) => id !== documentId);
  setInProgressIds(ids);
}


